import { CalendarDate, parseDate } from "@internationalized/date";

/** Parse an ISO `YYYY-MM-DD` string into a CalendarDate, or null if empty/invalid. */
export function parseIsoDate(value: string | null | undefined): CalendarDate | null {
  if (!value?.trim()) return null;
  try {
    return parseDate(value);
  } catch {
    return null;
  }
}
